/*=============================================
|                 IMPORTS                     |
=============================================*/


/*=============================================
|                CONSTANTES                   |
=============================================*/



/*=============================================
|                  UTILS                      |
=============================================*/
const formatDate = (date,way) => {
    if (!date) return null
    
    const [day,month,numberDay,year] = date.split(' ')

    switch(way) {
        case 0:
            return `${numberDay}/${month}/${year}`
          break;
        case 1:
            return `${numberDay} de ${month} de ${year}`
          break;
        case 2:
            let months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
            let indexMonth = month.substring(1,2)
            
            let selectedMonthName = months[(indexMonth)-1];
            return `${day} ${selectedMonthName} ${year}`
          break;
        
        default:
          break;
      } 
  
   
}

const formatAmount = (amount) => {
    let val = (amount/1).toFixed(2).replace(',', '.')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

const formatPhoneNumber = (phoneNumber) => {
    let val = phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    let formattedPhone = !val[2] ? val[1] : '(' + val[1] + ') ' + val[2] + (val[3] ? '-' + val[3] : '');
    return formattedPhone
}



/*=======EXPORT=========*/
export default {
    formatDate,
    formatAmount,
    formatPhoneNumber

}